import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Grid,
  Stack,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
function OrderItemsCard() {
  return (
    <InfoCard title="Order Items"  count={6}>
      <Stack spacing={1.5}>
        {/* Header */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 60px 70px 90px",
            alignItems: "center",
            color: "text.secondary",
            fontWeight: 600,
          }}
        >
          <Typography fontSize={12} sx={{ m: 0 }}>
            Item
          </Typography>
          <Typography fontSize={12} align="center" sx={{ m: 0 }}>
            Qty
          </Typography>
          <Typography fontSize={12} align="right" sx={{ m: 0 }}>
            Price
          </Typography>
          <Typography fontSize={12} align="center" sx={{ m: 0 }}>
            Status
          </Typography>
        </Box>

        <Divider />

        {/* Row */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 60px 70px 90px",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            fontSize={13}
            sx={{
              m: 0,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title="Tetssgss long product name example"
          >
            Tes00000000000000000000
          </Typography>

          <Typography fontSize={13} align="end" sx={{ m: 0 }}>
            02
          </Typography>

          <Typography fontSize={13} align="right" sx={{ m: 0 }}>
            ₹1
          </Typography>

          <Chip
            label="Pending"
            size="small"
            sx={{
              bgcolor: "#fff3e0",
              color: "#ef6c00",
              fontSize: 11,
              height: 22,
              justifySelf: "center",
            }}
          />
        </Box>
      </Stack>
    </InfoCard>
  );
}

/* ---------------- InfoCard ---------------- */

function InfoCard({ title, children,count }) {
  return (
    <Card
      sx={{
        bgcolor: "#eef7f4",
        border: "1px solid #d9efe6",
        borderRadius: 1.5,
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Typography fontWeight={600} fontSize={14} mb={1}>
          {title}:{count}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {children}
      </CardContent>
    </Card>
  );
}


export default function OrderStatusDesktop() {
  return (
    <Box sx={{ bgcolor: "#f4f6f5", minHeight: "100vh", py: 4 }}>
      <Box sx={{ maxWidth: 1100, mx: "auto", px: 2 }}>
        {/* Header */}
        <Card sx={{ mb: 3 }}>
          <CardContent
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              bgcolor: "#ffe14d",
            }}
          >
            <ArrowBackIcon />
            <Typography variant="h6" fontWeight={600}>
              Order Status
            </Typography>
          </CardContent>
        </Card>

        <Grid container spacing={3}>
          {/* LEFT – Timeline */}
          <Grid item xs={12} md={5}>
            <Card>
              <CardContent>
                <Typography fontWeight={600} mb={2}>
                  Refund Progress
                </Typography>

                <TimelineItem
                  title="Refund Initiated"
                  subtitle="Refund Ref No: 173782"
                  time="12/1/2026, 12:15:48 pm"
                />

                <Divider sx={{ my: 2 }} />

                <TimelineItem
                  title="Refund Successful"
                  time="12/1/2026, 12:38:00 pm"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* RIGHT – Details */}
          <Grid item xs={12} md={7}>
            <Stack spacing={3}>
              <InfoCard title="Refunded Amount : ₹ 2">
                <InfoRow label="Date" value="12/1/2026, 12:38:00 pm" />
                <InfoRow label="Transaction ID" value="173782" />
                <InfoRow label="Refund Account" value="WALLET" />
              </InfoCard>

<OrderItemsCard/>

              <InfoCard title="Paid Amount : ₹ 2">
                <InfoRow label="Date" value="12/1/2026, 12:00:48 pm" />
                <InfoRow label="Transaction ID" value="173782" />
                <InfoRow label="Payment Method" value="WALLET" />
              </InfoCard>

              <Card>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography fontWeight={500}>
                    Have Any Concerns?
                  </Typography>
                  <Button
                    variant="outlined"
                    color="success"
                    sx={{ fontWeight: 600 }}
                  >
                    RAISE A TICKET
                  </Button>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

/* ---------------- Components ---------------- */

function TimelineItem({ title, subtitle, time }) {
  return (
    <Stack direction="row" spacing={2}>
      <CheckCircleIcon color="success" />
      <Box>
        <Typography fontWeight={600}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">
          {time}
        </Typography>
      </Box>
    </Stack>
  );
}

/* function InfoCard({ title, children }) {
  return (
    <Card sx={{ bgcolor: "#eef7f4" }}>
      <CardContent>
        <Typography fontWeight={600} mb={1}>
          {title}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {children}
      </CardContent>
    </Card>
  );
}
 */
function InfoRow({ label, value }) {
  return (
    <Stack direction="row" justifyContent="space-between" mb={0.5}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Stack>
  );
}
